import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  searchPlaceholder: theme => ({
    borderWidth: 1,
    paddingVertical: 18,
    paddingHorizontal: 12,
    borderRadius: 6,
    borderColor: theme.colors.shimmerBorder,
  }),
  titlePlaceholder: theme => ({
    marginTop: 30,
    paddingBottom: 20,
  }),
  contactImagePlaceholder: {
    width: 25,
    height: 25,
    borderRadius: 12.5,
    marginStart: 6,
    marginEnd: 23,
  },
  contactItemPlaceholder: theme => ({
    paddingTop: 17,

    paddingBottom: 14,
  }),
  contactNamePlaceholder: {
    marginBottom: 8,
    height: 12,
  },

  linePlaceholderHeight: {
    height: 12,
  },
  seperator: {
    height: 1,
  },
});
